import { Website } from "@/components/website/website";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/website/")({
  component: Website,
});
